import { instance } from "libs/api";

import { ApiRoutesMarketing } from "../../constants";
import { RecipientPreview, SegmentDefinition } from "../../marketing.types";

export const requestPreviewRecipients = async (
  definition: SegmentDefinition
): Promise<RecipientPreview[]> => {
  return await instance.post(
    ApiRoutesMarketing.SegmentsPreviewRecipients,
    definition
  );
};
